import * as React from 'react';
import {useDispatch} from 'react-redux';

import type {FilterObject} from 'nutshell-core/types';

import {DashboardCard} from 'shells/dashboard/card/dashboard-card';
import {Illustration} from 'shells/illustrations/illustration';
import {PromoStateOverlay} from 'shells/promo-state-overlay/promo-state-overlay';

import {useOpenableModal, OpenableModals} from '../../openable-modals';

// @ts-expect-error
import {useGetChannelDashboard} from './graphql/hooks';
import * as actions from './report/chat/chat-actions';
import {ChatbotChart} from './report/chat/chatbot-chart';

import styles from './dashboard.module.css';

type Props = {
    dateRange: string;
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => void;
    shouldShowPromo: boolean;
};

export function ChatbotCard(props: Props) {
    const {activeFilters} = props;

    const {channelDashboard, isLoading} = useGetChannelDashboard({
        timespan: props.dateRange,
        channelType: 'chatbot',
    });

    const {onOpen: onOpenEmbedChatModal} = useOpenableModal(OpenableModals.EMBED_CHAT_MODAL);

    const dispatch = useDispatch();

    const stats = channelDashboard ? channelDashboard.stats : [];

    const reportParams = {
        dateRangeType: 'period',
        facet: 'count',
        gap: 'd',
        segment: 'interactionType',
    } as const;

    React.useEffect(() => {
        dispatch(
            actions.requestChatbotReportData({
                reportParams,
                filters: activeFilters,
            })
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeFilters]);

    return (
        <DashboardCard
            title='AI Chatbot'
            subtitle='Have your chatbot answer common questions'
            isLoading={isLoading}
            mainContent={{
                statsProps: {stats},
                content: (
                    <div className={styles.chart}>
                        <ChatbotChart
                            activeFilters={props.activeFilters}
                            onParamChange={props.onParamChange}
                            reportParams={reportParams}
                            height={346}
                            containerHeight={346}
                        />
                    </div>
                ),
            }}
            promoStateOverlay={
                props.shouldShowPromo ? (
                    <PromoStateOverlay
                        promoStateProps={{
                            isHorizontal: true,
                            imageComponent: (
                                <Illustration src='trial-onboarding/engagement-chat-snippet' />
                            ),
                            title: 'Embed chat on your website',
                            subtitle:
                                'Copy and paste a code snippet to all the webpages you want chat to appear.',
                            primaryCta: null,
                            secondaryCta: {
                                text: 'Embed chat',
                                onClick: onOpenEmbedChatModal,
                            },
                            blueImageBackground: true,
                        }}
                    />
                ) : null
            }
        />
    );
}
